var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue';
import { unref as _unref, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass, withModifiers as _withModifiers, vShow as _vShow, withDirectives as _withDirectives, mergeProps as _mergeProps, Teleport as _Teleport, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function (n) { return (_pushScopeId("data-v-0c993421"), n = n(), _popScopeId(), n); };
var _hoisted_1 = ["id"];
var _hoisted_2 = /*#__PURE__*/ _withScopeId(function () { /*#__PURE__*/ return _createElementVNode("span", {
    "aria-hidden": "true",
    class: "hidden sm:inline-block sm:align-middle sm:h-screen"
}, "​", -1); });
var _hoisted_3 = /*#__PURE__*/ _withScopeId(function () { /*#__PURE__*/ return _createElementVNode("span", { class: "sr-only" }, "Закрыть", -1); });
import { ref, computed, watch, nextTick, onMounted, onBeforeUnmount } from 'vue';
import { useDialog } from '@common/hooks';
import EIcon from '@common/ui/EIcon.vue';
import { generateId } from '@common/utils/Helpers/Helpers';
export default /*#__PURE__*/ _defineComponent(__assign({
    inheritAttrs: false
}, { __name: 'EDialog', props: /*#__PURE__*/ _mergeModels({
        name: {},
        size: { default: 'sm' },
        centerContent: { type: Boolean, default: true },
        noPadding: { type: Boolean },
        closeByUser: { type: Boolean, default: true },
        appendToBody: { type: Boolean, default: true },
        background: { default: 'white' },
        forciblyHideBody: { type: Boolean },
        customPadding: {},
        allowFullscreen: { type: Boolean }
    }, {
        "visible": __assign({ type: Boolean }, { required: true }),
        "visibleModifiers": {},
    }), emits: /*#__PURE__*/ _mergeModels(["closed", "opened", "close", "open", "fullscreen"], ["update:visible"]), setup: function (__props, _a) {
        var _this = this;
        var __expose = _a.expose, __emit = _a.emit;
        var sizeToClass = {
            sm: [
                'sm:rounded-lg',
                'sm:my-8',
                'sm:align-middle',
                'sm:p-8',
                'sm:max-w-lg',
                'sm:h-auto',
                'sm:overflow-y-visible',
            ],
            md: [
                'md:rounded-lg',
                'md:my-8',
                'md:align-middle',
                'md:p-8',
                'md:max-w-xl',
                'md:h-auto',
                'md:overflow-y-visible',
            ],
            lg: [
                'lg:rounded-lg',
                'lg:my-8',
                'lg:align-middle',
                'lg:p-8',
                'lg:max-w-3xl',
                'lg:h-auto',
                'lg:overflow-y-visible',
            ],
            xl: [
                'xl:rounded-lg',
                'xl:my-8',
                'xl:align-middle',
                'xl:p-8',
                'xl:max-w-6xl',
                'xl:h-auto',
                'xl:overflow-y-visible',
            ],
            fitContent: [
                'xl:rounded-lg',
                'xl:align-middle',
                'xl:w-fit',
                'xl:h-fit',
            ],
            full: [
                'rounded-none',
                'my-0',
                'align-bottom',
                // базовый блок уже имеет w-screen/h-screen; дублирование не повредит
                'w-screen',
                'h-screen',
                'max-w-full',
                'max-h-full',
                'overflow-y-auto',
            ],
        };
        // todo: closeOnPressEscape
        // closeOnClickModal
        // lockScroll
        var props = __props;
        var emit = __emit;
        var visibleModel = _useModel(__props, 'visible');
        var modalName = computed(function () { return "modal-".concat(props.name || 'empty-name', "-").concat(generateId()); });
        var dialogRef = ref();
        var key = ref(0);
        var _b = useDialog({
            closeByUser: props.closeByUser,
            onOpen: function () {
                if (visibleModel.value)
                    return;
                visibleModel.value = true;
                emit('open');
            },
            onClose: function () {
                if (!visibleModel.value)
                    return;
                visibleModel.value = false;
                emit('close');
            }
        }), open = _b.open, close = _b.close, zIndex = _b.zIndex, isOpened = _b.isOpened
        // eslint-disable-next-line vue/no-setup-props-destructure
        ;
        var isFullscreen = ref(typeof props.size === 'string' && props.size === 'full');
        watch(function () { return props.size; }, function (val) {
            if (typeof val === 'string') {
                isFullscreen.value = (val === 'full');
            }
        });
        watch(isFullscreen, function (val, oldVal) {
            if (val !== oldVal)
                emit('fullscreen', val);
        });
        var baseSizeClasses = computed(function () {
            if (typeof props.size === 'string' && sizeToClass[props.size])
                return sizeToClass[props.size];
            if (Array.isArray(props.size))
                return props.size;
            return [props.size];
        });
        var contentSizeClasses = computed(function () { return (isFullscreen.value ? sizeToClass.full : baseSizeClasses.value); });
        var toggleFullscreen = function () {
            if (!props.allowFullscreen)
                return;
            isFullscreen.value = !isFullscreen.value;
            nextTick(function () { if (dialogRef.value)
                dialogRef.value.scrollTop = 0; });
        };
        onBeforeUnmount(function () {
            close();
        });
        watch(visibleModel, function (val, oldVal) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!val) return [3 /*break*/, 2];
                        // emit('open');
                        open();
                        // ! Раньше при скролле модалки ломались ESelectDropdown и EDropdownMenu, после отказа надо проверить что все ок
                        // todo
                        // this.$el.addEventListener('scroll', this.updatePopper);
                        return [4 /*yield*/, nextTick()];
                    case 1:
                        // ! Раньше при скролле модалки ломались ESelectDropdown и EDropdownMenu, после отказа надо проверить что все ок
                        // todo
                        // this.$el.addEventListener('scroll', this.updatePopper);
                        _a.sent();
                        if (dialogRef.value) {
                            dialogRef.value.scrollTop = 0;
                        }
                        return [3 /*break*/, 3];
                    case 2:
                        // Не вызываем закрытие, если модалка уже закрыта
                        if (!isOpened())
                            return [2 /*return*/];
                        close();
                        _a.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        }); });
        onMounted(function () {
            if (visibleModel.value) {
                open();
            }
        });
        var onUserClose = function () {
            if (props.closeByUser) {
                close();
            }
        };
        var afterEnter = function () {
            emit('opened');
        };
        var afterLeave = function () {
            emit('closed');
        };
        __expose({
            open: open,
            close: close,
        });
        return function (_ctx, _cache) {
            return (_openBlock(), _createBlock(_Teleport, {
                disabled: !_ctx.appendToBody,
                to: "#modals"
            }, [
                _createElementVNode("div", _mergeProps(_ctx.$attrs, { id: modalName.value }), [
                    _createVNode(_Transition, { name: "e-dialog__overlay-fade" }, {
                        default: _withCtx(function () { return [
                            (visibleModel.value)
                                ? (_openBlock(), _createElementBlock("div", {
                                    key: 0,
                                    style: _normalizeStyle({
                                        zIndex: _unref(zIndex)
                                    }),
                                    class: "e-dialog__overlay"
                                }, null, 4))
                                : _createCommentVNode("", true)
                        ]; }),
                        _: 1
                    }),
                    _createVNode(_Transition, {
                        name: "e-dialog-fade",
                        onAfterEnter: afterEnter,
                        onAfterLeave: afterLeave
                    }, {
                        default: _withCtx(function () { return [
                            (!_ctx.forciblyHideBody || visibleModel.value)
                                ? _withDirectives((_openBlock(), _createElementBlock("div", {
                                    key: 0,
                                    class: _normalizeClass([{
                                            'e-dialog--visible': visibleModel.value,
                                            'e-dialog--no-padding': _ctx.noPadding
                                        }, "e-dialog"]),
                                    style: _normalizeStyle({
                                        zIndex: _unref(zIndex)
                                    })
                                }, [
                                    _createElementVNode("div", {
                                        class: "flex relative justify-center items-center min-h-screen text-center",
                                        onMousedown: _withModifiers(onUserClose, ["self"])
                                    }, [
                                        _hoisted_2,
                                        _renderSlot(_ctx.$slots, "body", {}, function () { return [
                                            (_openBlock(), _createElementBlock("div", {
                                                key: key.value,
                                                ref_key: "dialogRef",
                                                ref: dialogRef,
                                                class: _normalizeClass([__spreadArray([
                                                        {
                                                            'items-center': _ctx.centerContent,
                                                            'items-start': !_ctx.centerContent,
                                                            'bg-white': _ctx.background === 'white',
                                                            'bg-gray-50': _ctx.background === 'gray',
                                                        }
                                                    ], __read(contentSizeClasses.value), false), "inline-flex overflow-y-auto flex-col px-6 pt-7 pb-6 w-screen max-w-full h-screen max-h-full text-left align-bottom bg-white transform shadow-custom e-dialog__content"]),
                                                "aria-labelledby": "modal-headline",
                                                "aria-modal": "true",
                                                role: "dialog"
                                            }, [
                                                (_ctx.closeByUser)
                                                    ? (_openBlock(), _createElementBlock("div", {
                                                        key: 0,
                                                        class: _normalizeClass([_ctx.customPadding ? _ctx.customPadding : 'pt-4', "flex gap-2 absolute top-0 right-0 pr-4 z-10"])
                                                    }, [
                                                        (_ctx.allowFullscreen)
                                                            ? (_openBlock(), _createElementBlock("button", {
                                                                key: 0,
                                                                class: "w-7 h-7 flex items-center justify-center bg-transparent text-gray-400 rounded-md hover:text-gray-500 hover:bg-gray-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-200 transition-colors",
                                                                type: "button",
                                                                onClick: toggleFullscreen
                                                            }, [
                                                                _createVNode(EIcon, {
                                                                    icon: isFullscreen.value ? 'fullscreen-exit' : 'fullscreen-arrows',
                                                                    class: "w-4 h-4"
                                                                }, null, 8, ["icon"])
                                                            ]))
                                                            : _createCommentVNode("", true),
                                                        _createElementVNode("button", {
                                                            class: "w-7 h-7 flex items-center justify-center bg-transparent text-gray-400 rounded-md hover:text-gray-500 hover:bg-gray-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-200 transition-colors",
                                                            type: "button",
                                                            onClick: onUserClose
                                                        }, [
                                                            _hoisted_3,
                                                            _createVNode(EIcon, {
                                                                class: "w-3 h-3",
                                                                icon: "close"
                                                            })
                                                        ])
                                                    ], 2))
                                                    : _createCommentVNode("", true),
                                                _renderSlot(_ctx.$slots, "default")
                                            ], 2))
                                        ]; })
                                    ], 32)
                                ], 6)), [
                                    [_vShow, _ctx.forciblyHideBody || visibleModel.value]
                                ])
                                : _createCommentVNode("", true)
                        ]; }),
                        _: 3
                    })
                ], 16, _hoisted_1)
            ], 8, ["disabled"]));
        };
    } }));
